import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'Joining FitClub was the best decision I made — with the perfect plan and program, I transformed my body and my confidence! ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:' With the right guidance from FitClub, I stayed consistent and focused, and now I’ve reached the strongest version of myself!',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
